import React from 'react';
import {
  Button, Dialog, DialogContent, DialogTitle,
} from '@material-ui/core';
import { formatISO2DisplayDateString, formatISO2DisplayTimeString } from 'utils/dateFunctions';
import i18n from 'i18n';

import './ReportModal.css';

// eslint-disable-next-line react/jsx-props-no-spreading
export function ReportModal({
  show, dismountModal, title, contextText, body, practitioner, auxPractitioner, isoDate, findOrganization, organization,
}) {
  return (
    <Dialog
      onClose={dismountModal}
      aria-labelledby="customized-dialog-title"
      open={show}
      className="reportModal-container"
      maxWidth={false}
      scroll="body"
    >
      <DialogTitle id="customized-dialog-title" onClose={dismountModal}>
        <p className="reportModal-headerTitle">{title}</p>
        <p className="reportModal-headerPractitioner">
          Profissional:
          {' '}
          {
            (auxPractitioner && typeof auxPractitioner !== 'number') ? auxPractitioner : practitioner
          }
        </p>
        <p className="reportModal-headerOrganization">
          {organization?.toUpperCase() || findOrganization?.toUpperCase()}
        </p>
        <p className="reportModal-headerDateAndTime">
          {formatISO2DisplayDateString(isoDate, i18n.language)}
          {' '}
          {formatISO2DisplayTimeString(isoDate, i18n.language)}
        </p>
      </DialogTitle>
      <DialogContent className="reportModal-contentArea">
        {body}
      </DialogContent>
      <Button
        onClick={dismountModal}
        className="reportModal-closeButton"
        variant="contained"
        style={{ backgroundColor: 'var(--button-primary-color)', color: 'var(--primary-text-color)' }}
        disableElevation
      >
        Fechar
      </Button>
    </Dialog>
  );
}
